import ClearItemInCart from "./clear-item-in-cart.component";

export default ClearItemInCart;
